
import { ChatMessage } from "@/store/modules/Chat";
import { WsClient } from "@/ws/WsClient";
import { computed, defineComponent, inject, ref } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  setup() {
    const store = useStore();
    // const chat = ref<Message[]>([]);
    const chat = (computed(
      () => store.getters.getChat
    ) as unknown) as ChatMessage[];

    const inputMessage = ref("");
    const messageCount = computed(() =>
      inputMessage.value.length <= 999 ? inputMessage.value.length : 999
    );

    const chatRef = ref<HTMLElement | null>(null);
    /**
     * Move the scrollbar of the chat at the very bottom when sending a new message
     */
    const scrollChat = () => {
      // scroll back to the bottom upon sending a new message
      if (chatRef.value) {
        const chatEl = chatRef.value;
        // only scroll if there is a scrollbar
        if (chatEl.scrollHeight > chatEl.clientHeight) {
          // only scroll if the scroll bar is not all the way to the bottom upon sending a message
          if (chatEl.scrollTop != 0) {
            chatEl.scrollTop = 0;
          }
        }
      }
    };
    const ws = inject("ws") as WsClient;
    /**
     * send an answer to the server
     */
    const answer = () => {
      if (!inputMessage.value && inputMessage.value.length > 100) return;
      ws.dispatch.answer(inputMessage.value);
      // scroll the chat to the bottom after sending a message
      scrollChat();
      inputMessage.value = "";
    };

    // if the current game does not feature a turn system, render the chat input without further checks
    const hasTurn = computed<boolean>(() => store.getters.getHasTurns);
    // if not, and if the current client is currently playing, dont render the answer input
    const isTurn = computed<boolean>(() => store.getters.getIsTurn);
    const renderChatInput = computed<boolean>(() => {
      if (!hasTurn.value) {
        return true;
      } else {
        if (isTurn.value) {
          return false;
        } else return true;
      }
    });

    return {
      chat,
      inputMessage,
      messageCount,
      answer,
      renderChatInput,
      chatRef,
      showChat: computed(() => store.getters.getShowChat),
    };
  },
});
